// material-ui
import { styled } from '@mui/material/styles';
import Drawer from '@mui/material/Drawer';

// project imports
import { DRAWER_WIDTH, MINI_DRAWER_WIDTH } from 'config';
const openedMixin = (theme) => ({
  width: DRAWER_WIDTH,
  flex: '1 1 auto',
  height: '100%',
  minHeight: '100vh',
  display: 'flex',
  flexDirection: 'column',
  borderRight: '1px solid',
  borderRightColor: '#e0e0e0',
  backgroundColor: '#ffffff',
  color: theme.palette.text.primary,
  zIndex: theme.zIndex.drawer + 2,

  transition: theme.transitions.create('width', {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.enteringScreen
  }),

  scrollbarWidth: 'none',
  msOverflowStyle: 'none',
  '&::-webkit-scrollbar': { width: 0, height: 0, display: 'none' },

  overflow: 'visible',
  boxShadow: 'none'
});

const closedMixin = (theme) => ({
  transition: theme.transitions.create('width', {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen
  }),

  flex: '1 1 auto',
  height: '100%',
  minHeight: '100vh',
  display: 'flex',
  flexDirection: 'column',
  overflow: 'visible',
  scrollbarWidth: 'none',
  msOverflowStyle: 'none',
  '&::-webkit-scrollbar': { width: 0, height: 0, display: 'none' },
  width: MINI_DRAWER_WIDTH,
  borderRight: '1px solid',
  borderRightColor: '#e0e0e0',
  backgroundColor: '#ffffff',
  color: theme.palette.text.primary,
  zIndex: theme.zIndex.drawer + 2,
  boxShadow: theme.vars.customShadows.z1
});

// ==============================|| DRAWER - MINI STYLED ||============================== //

const MiniDrawerStyled = styled(Drawer, { shouldForwardProp: (prop) => prop !== 'open' })(({ theme }) => ({
  width: DRAWER_WIDTH,
  flexShrink: 0,
  whiteSpace: 'normal',
  boxSizing: 'border-box',
  overflow: 'visible',
  zIndex: theme.zIndex.drawer + 2,
  variants: [
    {
      props: ({ open }) => open,
      style: { ...openedMixin(theme), '& .MuiDrawer-paper': openedMixin(theme) }
    },
    {
      props: ({ open }) => !open,
      style: { ...closedMixin(theme), '& .MuiDrawer-paper': closedMixin(theme) }
    }
  ]
}));

export default MiniDrawerStyled;
